const thumbSlider = new Swiper('.thumbnail-swiper', {
    direction: 'vertical',
    slidesPerView: 'auto',
    // spaceBetween: 7,
    watchSlidesProgress: true,
    autoHeight: true,
    autoWidth: true,
    mousewheel: {
        enabled: true,
        sensitivity: 1, // Adjust sensitivity (0.1 to 10)
        releaseOnEdges: true, // Release when reaching edges
    },
});

const mainSlider = new Swiper('.main-swiper', {
    spaceBetween: 4,
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1.1,
            spaceBetween: 9,
        },
        749: {
            slidesPerView: 1,
            spaceBetween: 4,
        }
    },
    thumbs: {
        swiper: thumbSlider,
    }
});
